webpackJsonp([280947666601047],{

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _Segment3 = __webpack_require__(229);
	
	var _Segment4 = _interopRequireDefault(_Segment3);
	
	var _Label3 = __webpack_require__(112);
	
	var _Label4 = _interopRequireDefault(_Label3);
	
	var _Header3 = __webpack_require__(29);
	
	var _Header4 = _interopRequireDefault(_Header3);
	
	var _Container3 = __webpack_require__(26);
	
	var _Container4 = _interopRequireDefault(_Container3);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(50);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _disqusReact = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPage = function BlogPage(_ref) {
	  var edges = _ref.data.allMarkdownRemark.edges;
	
	  var Posts = edges.filter(function (edge) {
	    return !!edge.node.frontmatter.date;
	  }).map(function (_ref2) {
	    var post = _ref2.node.frontmatter;
	
	    return _react2.default.createElement(
	      _Segment4.default,
	      { key: post.id, stacked: true, textAlign: 'center', padded: 'very' },
	      _react2.default.createElement(_Header4.default, { as: 'h2', content: _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: post.path },
	          post.title
	        ) }),
	      _react2.default.createElement(_Label4.default, { icon: 'time', size: 'tiny', basic: true, content: post.date }),
	      _react2.default.createElement(_Label4.default, {
	        icon: 'comment',
	        size: 'tiny',
	        basic: true,
	        content: _react2.default.createElement(_disqusReact.CommentCount, {
	          shortname: 'fake-flight-tickets',
	          config: {
	            url: 'https://www.fakeflighttickets.com' + post.path,
	            identifier: post.id,
	            title: post.title
	          }
	        })
	      })
	    );
	  });
	
	  return _react2.default.createElement(
	    _Container4.default,
	    { text: true },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        '\u0411\u043B\u043E\u0433 - \u0424\u044D\u0439\u043A\u043E\u0432\u044B\u0435 \u0410\u0432\u0438\u0430\u0431\u0438\u043B\u0435\u0442\u044B'
	      ),
	      _react2.default.createElement('meta', { name: 'twitter:title', content: '\u0411\u043B\u043E\u0433 - \u0424\u044D\u0439\u043A\u043E\u0432\u044B\u0435 \u0410\u0432\u0438\u0430\u0431\u0438\u043B\u0435\u0442\u044B' }),
	      _react2.default.createElement('meta', { name: 'twitter:image', content: '/opengraph-image.ru.jpg' }),
	      _react2.default.createElement('meta', { property: 'og:image', content: '/opengraph-image.ru.jpg' })
	    ),
	    _react2.default.createElement(
	      _Header4.default,
	      { as: 'h1' },
	      '\u041D\u0430\u0448 \u0411\u043B\u043E\u0433'
	    ),
	    Posts,
	    _react2.default.createElement(
	      'center',
	      { style: { marginTop: '10vh' } },
	      '\u0425\u043E\u0442\u0438\u0442\u0435 \u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u0441\u0432\u043E\u044E \u0441\u0442\u0430\u0442\u044C\u044E \u0432 \u043D\u0430\u0448\u0435\u043C \u0431\u043B\u043E\u0433\u0435?',
	      _react2.default.createElement('br', null),
	      '\u0422\u043E\u0433\u0434\u0430 \u0448\u043B\u0438\u0442\u0435 ',
	      _react2.default.createElement(
	        'i',
	        null,
	        '\u043F\u043E\u043B\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442 \u0441\u0442\u0430\u0442\u044C\u0438'
	      ),
	      ' \u043D\u0430 \u043D\u0430\u0448',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        {
	          onClick: function onClick() {
	            window.open('mailto:hello' + '@' + 'fakeflighttickets.com', '_blank');
	          },
	          className: 'item',
	          target: '_blank' },
	        '\u0438\u043C\u044D\u0439\u043B'
	      ),
	      '.',
	      _react2.default.createElement('br', null),
	      '\u0415\u0441\u043B\u0438 \u0412\u0430\u0448\u0430 \u0441\u0442\u0430\u0442\u044C\u044F \u043D\u0430\u043C \u043F\u043E\u043D\u0440\u0430\u0432\u0438\u0442\u044C\u0441\u044F, \u0442\u043E \u043C\u044B \u0435\u0451 \u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u043C \u0438 \u0434\u0430\u0436\u0435 \u0434\u0430\u0434\u0438\u043C \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0435 \u0431\u0438\u043B\u0435\u0442\u0438\u043A\u0438 ;)'
	    )
	  );
	};
	
	exports.default = BlogPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-ru-js-793811a445f85dd520a3.js